import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CustomMessagesService } from 'src/app/services/custom-messages.service';
import { MessageService } from '@progress/kendo-angular-l10n';
import { NotificationService } from '@progress/kendo-angular-notification';
import { DialogContentBase, DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { IntlService } from '@progress/kendo-angular-intl';
import { ApiService } from 'src/app/services/http/api.service';
import { Pagamentos, Reservations, Fatura } from 'src/app/models/reservations.model';
import { SharingService } from 'src/app/services/sharing.service';

@Component({
    selector: 'app-reservations-invoice-component',
    templateUrl: './reservations-invoice.component.html'
})
export class ReservationsInvoiceComponent extends DialogContentBase implements OnInit {
    @ViewChild("container", { read: ViewContainerRef })
    public container: ViewContainerRef | undefined;
    public formGroup: FormGroup = new FormGroup({});
    public gridView: any[] = [];
    public formValue: Pagamentos = {
        id: 0,
        dataRegistoServidor: new Date(),
        dataAtualizacaoServidor: new Date(),
        refReserva: 0,
        reservaUID: '',
        dataCriacao: new Date(),
        dataAtualizacao: new Date(),
        estado: 0,
        descricaoEstado: '',
        metodoPagamento: 0,
        descricaoMetodoPagamento: '',
        prePagamento: false,
        montante: 0,
        fatura: {
            id: 0,
            dataRegistoServidor: new Date(),
            dataAtualizacaoServidor: new Date(),
            refPagamento: 0,
            dataCriacao: new Date(),
            dataAtualizacao: new Date(),
            estado: 0,
            descricaoEstado: '',
            faturaNumeroContribuinte: false,
            numeroContribuinte: '',
            iddoc: 0,
            identificacaodocumento: '',
            identidade: 0,
            idpagamento: 0,
        }
    };
    public customMsgService: CustomMessagesService;

    constructor(public msgService: MessageService, private sharingService: SharingService, private dialogService: DialogService, private notificationService: NotificationService, public override dialog: DialogRef, private intl: IntlService, private api: ApiService) {
        super(dialog);
        //this.setFormValues();
        this.customMsgService = this.msgService as CustomMessagesService;
        this.placeHolder.nome = this.customMsgService.translate('selecionartag');
    }

    ngOnInit(): void {
        //this.gridView = this.formValue;
        //console.log(this.formValue);
        this.setFormValues();
        //console.log(this.formValue);

    }

    public placeHolder: any = {
        nome: "",
        id: undefined,
    };

    public setFormValues() {
        this.gridView = [this.formValue?.fatura];
        console.log('this.gridView');
        console.log(this.gridView);

    }
}